import '@babel/polyfill'
import Vue from 'vue'
import './plugins/axios'
import App from './App.vue'
import router from './router'
import store from './store'
import Buefy from 'buefy'
/* import 'buefy/dist/buefy.css' */
import device from 'vue-device-detector'
import 'animate.css'
import 'fullpage-vue/src/fullpage.css'
import VueFullpage from 'fullpage-vue'
import VueAwesomeSwiper from 'vue-awesome-swiper'
import 'swiper/css/swiper.css'
import '@mdi/font/css/materialdesignicons.css'
import './css/style.scss' // 2022.1 add
import VueYoutube from 'vue-youtube'
Vue.use(device)
Vue.use(Buefy)
Vue.use(VueFullpage)
Vue.use(VueYoutube)
Vue.use(VueAwesomeSwiper, {
	loop: true
})

Vue.config.productionTip = false

new Vue({
	router,
	store,
	render: h => h(App)
}).$mount('#app')
